const angular = require('angular');
const app = angular.module('learn-directives');
var html2canvasImport = require('../imports/html2canvas');
var jspdfImport = require('../imports/jspdf');
const moment = require('moment');

/**
 * Defines the change manager component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('certificate', [function() {
  return {
    restrict: 'E',
    scope: {
      user: '=',
      content: '=',
      completedDate: '=',
      close: '&',
      alt: '='
    },
    template: require('../../templates/directives/certificate.html'),
    controller: ['$scope', function ($scope, $window) {
      var self = this;
      self.info = {
        alt_title: null,
        hide_completion: false,
        completed_date: $scope.completedDate,
        user_name: $scope.user && $scope.user.first_name && ($scope.user.first_name + ' ' + $scope.user.last_name) || '',
        title: 'Untitled'
      };
      self.completed_date_external = 'test';


      var messageElm = document.querySelector('.certMessage');

      if (!$scope.content || !$scope.content.certificate || !$scope.content.certificate_data) {
        $scope.close();
        return;
      }

      if ($scope.alt && $scope.alt.length) {
        self.info.alt_title = $scope.alt;
      }

      $scope.content.certificate_data.forEach(function(item) {
        var name = item.name || '';
        if (name && item.value) {
          self.info[name] = item.value;
        }
      });

      self.print = async function () {
        const html2canvasModule = await html2canvasImport.importModule();
        const html2canvas = html2canvasModule.default;
        const jsPDFModule = await jspdfImport.importModule();
        const jsPDF = jsPDFModule.default;

        messageElm.setAttribute('class', 'certMessage certMessage--active');
        var originalCertElm = document.querySelector('.cert--original');
        var cloneWrapper = document.querySelector('.certClone');
        var pdf = new jsPDF({
          orientation: 'l',
          unit: 'in',
          format: [11,8.5]
        });
        var createCoverClone = function () {
          var cloneCertElm = originalCertElm.cloneNode(true);
          cloneCertElm.setAttribute('class', 'cert screenStyle cert--clone');
          cloneCertElm.setAttribute('id', 'certificateClone');
          cloneWrapper.appendChild(cloneCertElm);
          originalCertElm.setAttribute('class', 'cert cert--original printStyle');
        };
        createCoverClone();
        var dims = {
          width: (1059 * 3),
          height: (816 * 3),
          byDPI: {
            width: ((300) * 11),
            height: ((300) * 8.5)
          }
        };

        html2canvas(document.querySelector('.cert--original'), {
          allowTaint: true,
          backgroundColor: "#009FDF",
          foreignObjectRendering: true,
          onclone: function(doc){
            doc.body.style.width = dims.byDPI.width + 'px';
            doc.body.style.height = dims.byDPI.height + 'px';
          },
          width: dims.width,
          height: dims.height
        }).then(function(canvas) {
          pdf.addImage(canvas, 'PNG', 0, 0, 11, 8.5);
          var filename = self.info.title + '_' + self.info.user_name + '_' + ($scope.completedDate && moment($scope.completedDate).format('MMDDYYYY') || '');
          pdf.save(filename.replace(/\s/g, '').toLowerCase() + '.pdf');
          originalCertElm.setAttribute('class', 'cert cert--original screenstyle');
          document.querySelector('.certClone').innerHTML = '';
          messageElm.setAttribute('class', 'certMessage');
        });
      };

      self.info.title = $scope.content && ($scope.content.title || $scope.content.name) || 'Untitled';
      if (self.info.alt_title) {
        self.info.title = self.info.alt_title;
      }

    }],
    controllerAs: 'cert'
  };
}]);
